export class StorageAccessor {
    static storage: Storage | false;

    public static getItem(key: string) {
        return this.storage && this.storage.getItem(key);
    }

    public static getObject<T>(key: string): T | null;
    public static getObject<T>(key: string, defaultValue: T): T;
    public static getObject<T>(key: string, defaultValue = null) {
        if (!this.storage) {
            return defaultValue;
        }

        const valueString = this.storage.getItem(key);
        if (valueString === null) {
            return defaultValue;
        }

        return JSON.parse(valueString) as T;
    }

    public static setItem(key: string, value: string) {
        this.storage && this.storage.setItem(key, value);
    }

    public static setObject<T>(key: string, value: T) {
        this.storage && this.storage.setItem(key, JSON.stringify(value));
    }

    public static removeItem(key: string) {
        this.storage && this.storage.removeItem(key);
    }

    public static clear() {
        this.storage && this.storage.clear();
    }
}
